<template>
  <div class="content">
    <div
      class="hero section-type-b bground-config-clean position-relative"
      :style="{ backgroundImage: `url('${backgroundCarImage()}')` }"
    >
      <div class="personal-container advertisements">
        <div class="row section-type-b pt-5">
          <div class="col-12 presentation-inner-padding-top2">
            <div>
              <h1 class="text-light text-center mb-24">
                {{ informacionCoche.nombre }}
              </h1>
              <p class="text-light text-center mb-64">
                {{ informacionCoche.descripcion }}
              </p>
            </div>
            <div class="car-description-hero">
              <div class="car-x2">
                <img
                  :src="informacionCoche.portada"
                  class="w-100 car-description-principal-center spark2020_1231"
                  :alt="informacionCoche.nombre"
                />
                <br />
                <div class="d-flex justify-content-center mb-24">
                  <span
                    :style="{ backgroundColor: informacionCoche.color }"
                    class="pointer-color-selector white"
                    @click="
                      setColorCar('spark2020_1231', informacionCoche.color, informacionCoche.portada)
                    "
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ribbon-thumbs d-flex justify-content-center mb-64"> -->
      <!-- <div
        v-bind:key="index"
        v-for="(imgCarousel, index) in informacionCoche.carrousel"
      >
        <a data-fancybox="gallery" :href="imgCarousel.urlImagen">
          <img
            :src="imgCarousel.urlImagen"
            class="w-100"
            style="max-width: 140px"
            alt="Fotografías de chevrolet spark en diferentes lugares, ciudad, carretera"
          />
        </a>
      </div> -->
      <!--
      <div>
        <a data-fancybox="gallery" :href="thumbs.one">
          <img src="@/assets/images/autos/chevrolet/spark/thumb/1.jpg" class="w-100" style="max-width: 140px;" alt="Fotografías de chevrolet spark en diferentes lugares, ciudad, carretera">
        </a>
      </div>
      <div>
        <a data-fancybox="gallery" :href="thumbs.two">
          <img src="@/assets/images/autos/chevrolet/spark/thumb/2.jpg" class="w-100" style="max-width: 140px;" alt="Fotografías de chevrolet spark en diferentes lugares, ciudad, carretera">
        </a>
      </div>
      <div>
        <a data-fancybox="gallery" :href="thumbs.three">
          <img src="@/assets/images/autos/chevrolet/spark/thumb/3.jpg" class="w-100" style="max-width: 140px;" alt="Fotografías de chevrolet spark en diferentes lugares, ciudad, carretera">
        </a>
      </div>
      <div>
        <a data-fancybox="gallery" :href="thumbs.four">
          <img src="@/assets/images/autos/chevrolet/spark/thumb/4.jpg" class="w-100" style="max-width: 140px;" alt="Fotografías de chevrolet spark en diferentes lugares, ciudad, carretera">
        </a>
      </div>
      <div>
        <a data-fancybox="gallery" :href="thumbs.five">
          <img src="@/assets/images/autos/chevrolet/spark/thumb/5.jpg" class="w-100" style="max-width: 140px;" alt="Fotografías de chevrolet spark en diferentes lugares, ciudad, carretera">
        </a>
      </div>
      -->
    <!-- </div> -->

    <div class="section-type-c pt-5 pb-5 mb-64">
      <div class="personal-container">
        <!-- <div class="mb-64">
          <h1  class="text-center">Spark 2020</h1>
          <h5 class="text-center">Lorem ipsum dolor sit amet consectetur adipisicing elit.</h5>
        </div> -->
        <div class="row car-search">
          <div class="col-12 col-lg-6 p-4 vertical-align">
            <div>
              <h2 class="mb-24">
                <!-- {{
                  informacionCoche.versiones.length > 0
                    ? informacionCoche.versiones[0].descripcion
                    : "No disponible"
                }} -->
                {{ informacionCoche.nombre }}
              </h2>
              <p>
                {{ informacionCoche.descripcion }}
              </p>
              <div class="row pt-4">
                <div class="col-12 col-lg-4">
                  <div class="d-flex">
                    <div>
                      <img
                        src="@/assets/images/transmission.svg"
                        class="m-2"
                        style="width: 40px !important"
                      />
                    </div>
                    <div>
                      <h5 class="font-weight-bold">Transmisión</h5>
                      <p>
                        <!-- {{
                          informacionCoche.versiones.length > 0
                            ? informacionCoche.versiones[0].controlTraccion
                            : "No disponible"
                        }} -->
                        No disponible
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="d-flex">
                    <div>
                      <img
                        src="@/assets/images/mpg.svg"
                        class="m-2"
                        style="width: 40px !important"
                      />
                    </div>
                    <div>
                      <h5 class="font-weight-bold">Rendimiento</h5>
                      <p>
                        <!-- {{
                          informacionCoche.versiones.length > 0
                            ? informacionCoche.versiones[0].rines
                            : "No disponible"
                        }} -->
                        No disponible
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="d-flex">
                    <div>
                      <img
                        src="@/assets/images/motor.svg"
                        class="m-2"
                        style="width: 40px !important"
                      />
                    </div>
                    <div>
                      <h5 class="font-weight-bold">Motor</h5>
                      <p>
                        <!-- {{
                          informacionCoche.versiones.length > 0
                            ? informacionCoche.versiones[0].rines
                            : "No disponible"
                        }} -->
                        No disponible
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-lg-6 p-4 bground-config-clean"
            :style="{ backgroundImage: `url('${informacionCoche.portada}')` }"
            style="min-height: 300px"
          ></div>
        </div>
      </div>
    </div>
    <!-- <div class="section-type-b pt-5 pb-5 mb-64 presentation">
      <div class="personal-container">
        <div class="mb-64">
          <h1 class="text-center text-light">Elije la versión que quieras</h1>
        </div>
        <div
          class="row section-type-c car-search justify-content-center horizontal-scroll-wrapper squares testimonial-group"
        >
          <CarVersion
            v-bind:key="index"
            v-for="(currentCoche, index) in informacionCoche.versiones"
            :id="currentCoche.idVersion"
            :title="currentCoche.version"
            :imgVercion="currentCoche.imagenVersion"
            :promotionCost="currentCoche.contado"
            :initialPayment="currentCoche.enganche"
            :monthlyCost="currentCoche.mensualidad"
            :stock="currentCoche.stock"
          >
          </CarVersion>
        </div>

        <div
          class="row contenedorCarusel"
          id="gallery"
          data-toggle="modal"
          data-bs-target="#exampleModal"
        >
          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-01.jpg?imwidth=650"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="0"
            />
          </div>
          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-02.jpg?imwidth=650"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="1"
            />
          </div>
          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-06.jpg?imwidth=320"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="2"
            />
          </div>
          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-03-v2.jpg?imwidth=650"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="3"
            />
          </div>

          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-04-v2.jpg?imwidth=650"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="0"
            />
          </div>
          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-05.jpg?imwidth=630"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="1"
            />
          </div>
          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-07.jpg?imwidth=320"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="2"
            />
          </div>
          <div class="col-12 col-sm-6 col-lg-3 noSpace">
            <img
              class="w-100 imagenCarucel"
              src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/interior/2021-tracker-gal-int-06-v2.jpg?imwidth=320"
              alt="First slide"
              data-bs-target="#carouselExample"
              data-slide-to="3"
            />
          </div>
        </div> 

        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div
                  id="carouselExample"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <ol class="carousel-indicators">
                    <li
                      data-bs-target="#carouselExample"
                      data-slide-to="0"
                      class="active"
                    ></li>
                    <li data-bs-target="#carouselExample" data-slide-to="1"></li>
                    <li data-bs-target="#carouselExample" data-slide-to="2"></li>
                    <li data-bs-target="#carouselExample" data-slide-to="3"></li>
                  </ol>
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-01.jpg?imwidth=650"
                        alt="First slide"
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-02.jpg?imwidth=650"
                        alt="Second slide"
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-06.jpg?imwidth=320"
                        alt="Third slide"
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-03-v2.jpg?imwidth=650"
                        alt="Fourth slide"
                      />
                    </div>

                    <div class="carousel-item">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-03-v2.jpg?imwidth=650"
                        alt="Fourth slide"
                      />
                    </div>

                    <div class="carousel-item">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-05.jpg?imwidth=630"
                        alt="Fourth slide"
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/exterior/2021-tracker-gal-ext-07.jpg?imwidth=320"
                        alt="Fourth slide"
                      />
                    </div>
                    <div class="carousel-item">
                      <img
                        class="d-block w-100"
                        src="https://www.chevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/crossovers-suvs/2021-tracker/gallery/01-images/interior/2021-tracker-gal-int-06-v2.jpg?imwidth=320"
                        alt="Fourth slide"
                      />
                    </div>
                  </div>
                  <a
                    class="carousel-control-prev"
                    href="#carouselExample"
                    role="button"
                    data-slide="prev"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next"
                    href="#carouselExample"
                    role="button"
                    data-slide="next"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->



    <div class="section-type-b pt-5 pb-5 mb-64">
      <div class="personal-container">
        <div class="mb-64">
          <h1 class="text-center">
            Las personas que vieron {{ informacionCoche.nombre }} también
            vieron:
          </h1>
        </div>
        <div class="row justify-content-center">
          <!--CocheCard-->
          <CocheCard
            v-bind:key="coche.idSeminuevo"
            v-for="coche in coches"
            :id="coche.idSeminuevo"
            :urlBackgroundImage="coche.portada"
            :carModel="coche.nombre"
            :stock="coche.stock"
            :releaseYear="coche.nombre"
            :initialPayment="coche.contado"
            :monthlyCost="coche.mensualidad"
            :colors="coche.colores"
            routeDescription="autos-semi-nuevos"
          ></CocheCard>
        </div>
      </div>
    </div>
    <!--Dream car-->
  </div>
</template>

<script>
import CarVersion from '@/components/CarVersion'
import CocheCard from '@/components/CocheCard'
import one from '@/assets/images/autos/chevrolet/spark/thumb/1.jpg'
import two from '@/assets/images/autos/chevrolet/spark/thumb/2.jpg'
import three from '@/assets/images/autos/chevrolet/spark/thumb/3.jpg'
import four from '@/assets/images/autos/chevrolet/spark/thumb/4.jpg'
import five from '@/assets/images/autos/chevrolet/spark/thumb/5.jpg'
export default {
  name: 'PreOwnedDescription',
  components: {
    CarVersion,
    CocheCard
  },
  data () {
    return {
      urlSpark: require('@/assets/images/autos/chevrolet/spark/orange.png'),
      backgroundCarImage: () => {
        const puentegegro = require('@/assets/images/puentegegro.jpeg')
        const guasave = require('@/assets/images/unnamed.jpeg')
        const mochis = require('@/assets/images/Los-Mochis-1.jpeg')
        const maza = require('@/assets/images/MAZATLAN.jpeg')
        switch (localStorage.getItem('suc')) {
          case '1':
            return mochis
          case '2':
            return guasave
          case '3':
            return puentegegro
          case '4':
            return maza
          default: {
            localStorage.setItem('suc', 3)
            return puentegegro
          }
        }
      },
      descriptionCarImage: require('@/assets/images/autos/chevrolet/spark/thumb/beat-hb-2020-masthead-segment.webp'),
      thumbs: {
        one: one,
        two: two,
        three: three,
        four: four,
        five: five
      },
      coches: [],
      idCoche: 0,
      informacionCoche: {
        versiones: []
      }
    }
  },
  methods: {
    setColorCar (arg1, arg2, arg3) {
      this.informacionCoche.portada = arg3
    }
  },
  async mounted () {
    this.idCoche = this.$route.params.id
    const suc = localStorage.getItem('suc')
    const a = await this.$http.get(`${this.API_URL}/web/vehicles/seminuevos-detalle?sucursal=${suc}&vehiculo=${this.idCoche}`)
    this.informacionCoche = a.data.data[0]
    const responseLocalAPI = await this.$http.get(
        `${this.API_URL}/web/vehicles/random`
      );
      this.coches = responseLocalAPI.data.data;

    // this.coches = a.data.data.random.filter(coche => coche.idSeminuevo !== null)
  }
} 
</script>

<style scoped>
.noSpace {
  padding-left: 0px;
  padding-right: 0px;
}
.imagenCarucel:hover {
  cursor: pointer;
  float: left;
  outline: 3px solid #cd9834;
  outline-offset: -8px;
  width: 100%;
}
.contenedorCarusel {
  padding-top: 40px;
}
</style>
